import { useAuth } from "@/context/AuthContext";
import { BadgeCheck } from "lucide-react";

export default function ApproverProfile() {
  const { user } = useAuth();
  const rows = [
    ["Name", user?.name],
    ["Email", user?.email],
    ["Department", user?.department],
    ["Contact Number", user?.phone || "—"],
    ["Organization", user?.org_name],
    ["Role", "Approver"],
  ];
  return (
    <div data-testid="approver-profile-page" className="space-y-4">
      <h1 className="font-heading text-2xl font-semibold tracking-tight">Profile</h1>
      <div className="rounded-lg border bg-card">
        <div className="flex items-center gap-3 border-b px-5 py-4">
          <div className="flex h-11 w-11 items-center justify-center rounded-full bg-slate-900 text-base font-semibold text-white">
            {user?.name?.[0]?.toUpperCase()}
          </div>
          <div>
            <p className="font-heading text-base font-semibold">{user?.name}</p>
            <p className="flex items-center gap-1 text-xs text-muted-foreground"><BadgeCheck className="h-3.5 w-3.5" /> Approver — approve / reject / comment only</p>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-x-6 gap-y-4 px-5 py-4 md:grid-cols-3">
          {rows.map(([k, v]) => (
            <div key={k}><p className="text-xs uppercase tracking-wide text-muted-foreground">{k}</p><p className="mt-1 text-sm font-medium" data-testid={`profile-${k.toLowerCase().replace(/\s+/g, "-")}`}>{v || "—"}</p></div>
          ))}
        </div>
      </div>
    </div>
  );
}
